import React from "react"
export function EmergencyCash(props) {
  return (
    <svg viewBox="0 0 32 32" {...props}>
      <g
        id="prefix__Emergency-cash-32x32-Copy"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M18.618 4.13l.084.072 6.769 6.77a.75.75 0 01.073.976l-.046.051H23.38l.499-.498-5.709-5.709-.562.56-.004-.004-2.121 2.121.003.004L11.963 12h-2.12l4.979-4.979-1.247-1.233-6.282 6.212H5.442a.747.747 0 01.148-.411l.074-.085L13.048 4.2a.75.75 0 01.971-.072l.084.072 1.78 1.76 1.758-1.757a.75.75 0 01.977-.073zm2.328 7.747l-.074.084-.04.038H18.7l.579-.572-.418-.414h2.11a.75.75 0 01-.024.864zM26 11a2 2 0 011.995 1.85L28 13v13a2 2 0 01-1.85 1.995L26 28H6a2 2 0 01-1.995-1.85L4 26V13a2 2 0 011.85-1.995L6 11h20zm0 1.5H6l-.09.008a.5.5 0 00-.402.402L5.5 13v13l.008.09a.5.5 0 00.402.402L6 26.5h20l.09-.008a.5.5 0 00.402-.402L26.5 26V13l-.008-.09a.5.5 0 00-.402-.402L26 12.5zm-4 4.25a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5zm0 1.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
          id="prefix__Shape"
          fill="currentColor"
          fillRule="nonzero"
        />
      </g>
    </svg>
  )
}
